import React from 'react';
import DocumentTitle from 'react-document-title';
import * as Connections from "../../utils/Connections.js";
import Icon from "@material-ui/core/Icon";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";
import { Bar } from 'react-chartjs-2';


class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            allOrders: [],
            filteredOrders: [],
            allFarmers: [],
            allVouchers: [],
            allExpenses: [],
            farmerId: null,
            allFarmerVouchers: false,
            farmerProfile: []


        };
        // this.updateActiveOrders=this.updateActiveOrders.bind(this);
        this.successGetFarmers = this.successGetFarmers.bind(this)
        this.successGetFarmerVouchers = this.successGetFarmerVouchers.bind(this)
        this.allFarmerVouchers = this.allFarmerVouchers.bind(this)
        this.handleError = this.handleError.bind(this)
        this.successGetVouchers = this.successGetVouchers.bind(this)
    }

    handleError(data) {
        //alert(data)
    }

    componentDidMount() {
        var data = {
            "type": "getMyFarmers",
        }
        Connections.performSecureRequest(data, this.successGetFarmers, this.handleError)

        var data1 = {
            "type": "getAllVouchersExpenditure"
        }
        Connections.performSecureRequest(data1, this.successGetVouchers, this.handleError)

    }

    successGetVouchers(data1) {
        let list = [];
        for (let i = 0; i < data1.length && i < 3; i++) {
            list.push(data1[i])
        }
        this.setState({
            allVouchers: list
        })
    }

    successGetFarmers(data) {
        let list = [];
        for (let i = 0; i < data.length && i < 3; i++) {
            list.push(data[i])
        }
        this.setState({
            allFarmers: list
        })
    }

    getFarmerImage(imageName) {
        return Connections.getProfileImageLink() + imageName
    }

    allFarmerVouchers(farmerId, farmer) {
        let self = this
        this.setState({
            farmerId: farmerId,
            allFarmerVouchers: true,
            farmerProfile: farmer
        }, function () {
            var data = {
                type: "getAllFundingExpenditurePerFarmer",
                farmerId: farmerId
            }
            Connections.performSecureRequest(data, self.successGetFarmerVouchers, self.handleError)
        })
    }

    successGetFarmerVouchers(data) {
        this.setState({
            allVouchers: data
        })
    }

    render() {
        const data1 = {
            labels: ['Coop', 'PYT', 'Sole Trader', 'CC'],
            datasets: [
                {
                    label: 'Company Types',
                    backgroundColor: 'rgba(255,99,132,0.2)',
                    borderColor: 'rgba(255,99,132,1)',
                    borderWidth: 1,
                    hoverBackgroundColor: 'rgba(255,99,132,0.4)',
                    hoverBorderColor: 'rgba(255,99,132,1)',
                    data: [22, 62, 20, 11]
                }
            ]
        };
        const data = {
            labels: ['0-10', '10-100', '100-1000', '1000'],
            datasets: [
                {

                    label: 'Farm Size',
                    type: 'line',
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: 'rgba(75,192,192,0.4)',
                    borderColor: 'rgba(75,192,192,1)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgba(75,192,192,1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 1,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: 'rgba(75,192,192,1)',
                    pointHoverBorderColor: 'rgba(220,220,220,1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: [65, 40, 22, 1]
                },
                {

                    label: 'Farm Ploughed',
                    type: 'bar',
                    fill: false,
                    lineTension: 0.1,
                    borderColor: '#EC932F',
                    backgroundColor: '#EC932F',
                    pointBorderColor: '#EC932F',
                    pointBackgroundColor: '#EC932F',
                    pointHoverBackgroundColor: '#EC932F',
                    pointHoverBorderColor: '#EC932F',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderWidth: 1,
                    pointHoverRadius: 5,
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: [50, 40, 21, 1]
                },

            ]
        };
        return (
            <DocumentTitle title="Khula - Home">
                <div className="main-content">
                    <div className="row">

                        <div>
                            <div className="home-slider">

                                <div className="slider-image">
                                    <img alt="banner" src="https://khula.co.za/images/farmerweek3.png" />
                                    <img alt="banner" src="https://khula.co.za/images/farmerweek4.png" />
                                    <img alt="banner" src="https://khula.co.za/images/farmerweek2.png" />
                                    <img alt="banner" src="https://khula.co.za/images/victor.png" />


                                </div>
                                <div className="slider-content">

                                    <h4>FARMER OF THE WEEK</h4>
                                    <h5>Victor Masilo</h5>
                                    <p>Mooinooi<br /> 165 Ha Citrus, Spinach, Baby Marrow</p>
                                </div>


                            </div>
                        </div>
                        <div className="col col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <div className="homecard">
                                {/*<Line data={data} />*/}
                                <Bar
                                    data={data}
                                    options={{
                                        maintainAspectRatio: false
                                    }}
                                />
                            </div>
                            <br />
                            <div className="homecard">
                                <Bar data={data1} />

                            </div>

                        </div>
                        <div className="col col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-2">
                            <div className="homecard">
                                <h5>New Farmers</h5>
                                {this.state.allFarmers.slice(0, 5).map((farmer,i) =>
                                    <div key={i} className="homeNewFarmers">
                                        <div
                                            className="homeNewFarmersContent col-xs-9 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                            <h6>{farmer.name + " " + farmer.surname} </h6>
                                        </div>
                                        <div className="homeNewFarmersImg col-xs-3 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                            <img alt="farmer" style={{ float: "right" }} src={this.getFarmerImage(farmer.image_name)} />
                                        </div>

                                        <div
                                            className="homeNewFarmersContent col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                            <p> Land Size: {farmer.farmSize} Ha <br />Ownership: {farmer.landOwnership}
                                                <br />Needs Funding: {farmer.fundingRequest}</p>
                                        </div>
                                    </div>
                                )}
                                {/*<Link to="/login"></Link>*/}
                                <Link to="/farmers"><Button variant="outlined"
                                    color="primary" style={{
                                        fontSize: "12px",
                                        width: "100%",
                                        color: "green",
                                        borderColor: "green"
                                    }}> See more | <Icon className="fa-upload">more_horiz</Icon></Button></Link>
                            </div>

                        </div>
                        <div className="col col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-2">
                            <div className="homecard">
                                <h5>Pending vouchers</h5>

                                {this.state.allVouchers.map((voucher, i) =>
                                    <div key={i} className="homevoucher">
                                        <h6>
                                            Voucher {voucher.voucher.id} | <strong>R {voucher.voucher.assignedAmount}</strong>
                                        </h6>
                                        <p>
                                            {voucher.voucher.farmerDetails.name + " " + voucher.voucher.farmerDetails.surname}
                                        </p>
                                        <Link to="/billing"><Button variant="outlined" color="primary" style={{
                                            fontSize: "12px",
                                            width: "100%",
                                            color: "green",
                                            borderColor: "green"
                                        }}><span style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "flex-start"
                                        }}><span>Pay | </span><img alt="icon" style={{ width: 18, height: 18, marginLeft: 5 }}
                                            src="/images/wallet-absa.png" className="fa-upload" /></span></Button></Link>

                                    </div>
                                )}

                            </div>
                        </div>

                        <div>
                        </div>


                    </div>

                </div>

            </DocumentTitle>
        );
    }

}

export default Home;



// WEBPACK FOOTER //
// ./src/pages/HomePageBabies/Home.js